export default "__VITE_ASSET__CGGeb6nh__"